export const initProgressState = 0;
export const initType = "idle";
export const finalPercentage = 100;
